import { Paper } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";

import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { ConfirmationDialog } from "@dzambalaorg/mui-dialog-confirmation";
import { Table } from "@dzambalaorg/ui-kit";
import { formatItem, formatPenalty } from "@framework/exchange";
import type { IPonziDeposit } from "@framework/types";

import { normalizeDuration } from "../../../../../../utils/time";

export interface IStakesDialogViewProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  viewItem: IPonziDeposit | null;
}

export const StakesDialogView = (props: IStakesDialogViewProps) => {
  const { viewItem, onConfirm, open, ...rest } = props;

  if (!open || !viewItem) {
    return null;
  }

  const { ponziRule } = viewItem;
  const { penalty } = ponziRule || { penalty: 0 };

  const { formatMessage } = useIntl();

  const handleConfirm = (): void => {
    onConfirm();
  };

  return (
    <ConfirmationDialog open={open} message="dialogs.view" onConfirm={handleConfirm} {...rest}>
      <Table.Container component={Paper}>
        <Table aria-label="table">
          <Table.Body>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.title" />
              </Table.Cell>
              <Table.Cell align="right">{ponziRule?.title}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.description" />
              </Table.Cell>
              <Table.Cell align="right">
                <RichTextDisplay data={ponziRule?.description} />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.deposit" />
              </Table.Cell>
              <Table.Cell align="right">{formatItem(ponziRule?.deposit)}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.reward" />
              </Table.Cell>
              <Table.Cell align="right">{formatItem(ponziRule?.reward)}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.durationAmount" />
              </Table.Cell>
              <Table.Cell align="right">
                {ponziRule?.durationAmount && ponziRule?.durationUnit
                  ? formatMessage(
                      { id: `enums.durationUnit.${ponziRule.durationUnit}` },
                      {
                        count: normalizeDuration({
                          durationAmount: ponziRule.durationAmount,
                          durationUnit: ponziRule.durationUnit,
                        }),
                      },
                    )
                  : null}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.penalty" />
              </Table.Cell>
              <Table.Cell align="right">{formatPenalty(penalty)}%</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Table.Container>
    </ConfirmationDialog>
  );
};
